import React from 'react'

import { useModal } from '@hooks/contexts/ModalContext/ModalContext'
import { useStoryReader } from '@hooks/book/useStoryReader'
import { PayRankProps, WithPayRankProps } from './interface'

function withPayRank(Component: React.FC<PayRankProps>) {
  function WithPayRank({ className, isDrawer = false }: WithPayRankProps) {
    const { data } = useStoryReader()
    const viewAllSponsorsModal = useModal({ modal: 'viewAllSponsors' })

    const handleViewAll = () => {
      if (!data?.id) return
      viewAllSponsorsModal.show({ bookId: data.id })
    }

    const newProps = {
      className,
      supporters: data?.supporters || [],
      isDrawer,
      handleViewAll,
    }

    if (!data?.supporters?.length) return null

    return <Component {...newProps} />
  }
  return WithPayRank
}

export { withPayRank }
